module.exports = __webpack_public_path__ + "s/img/Glam_M_4.39c09d15.jpg";